import { Component } from '@angular/core';

@Component({
  templateUrl: './test.html'
})
export class TestComponent {}


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/test/test.component.ts